// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VhPlvCqfhsS9tHwk8ORk{color:var(--content-negative-primary)}.m2YxhDdifgW_9MnY6wnW{color:var(--content-primary-tertiary);font-size:13px;font-weight:400}.G07q8YyQVOQexcbZD0y_{background-color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `VhPlvCqfhsS9tHwk8ORk`,
	"rightText": `m2YxhDdifgW_9MnY6wnW`,
	"textField": `G07q8YyQVOQexcbZD0y_`
};
export default ___CSS_LOADER_EXPORT___;
